var map = {
	"./academic-courses/AddEdit": [
		"7eff",
		"chunk-7756441f",
		"chunk-2d0e2944"
	],
	"./ads/AddEdit": [
		"b7b1",
		"chunk-7756441f",
		"chunk-2d2107da"
	],
	"./article-categories/AddEdit": [
		"a244",
		"chunk-7756441f",
		"chunk-2d207b27"
	],
	"./article-tags/AddEdit": [
		"0d4a",
		"chunk-7756441f",
		"chunk-2d0af0d7"
	],
	"./articles/AddEdit": [
		"dd15",
		"chunk-7756441f",
		"chunk-273822c8",
		"chunk-2d22939a"
	],
	"./attributes/AddEdit": [
		"4c44",
		"chunk-7756441f",
		"chunk-2d0cbe65"
	],
	"./boards/AddEdit": [
		"840e",
		"chunk-1a0a2d9f",
		"chunk-7756441f",
		"chunk-7ac7242a",
		"chunk-2c1f1eda"
	],
	"./campuses/AddEdit": [
		"c0b8",
		"chunk-7756441f",
		"chunk-0db8ed08"
	],
	"./courses/AddEdit": [
		"99d0",
		"chunk-7756441f",
		"chunk-af05546c"
	],
	"./disclaimers/AddEdit": [
		"fa57",
		"chunk-7756441f",
		"chunk-db83d184"
	],
	"./events/AddEdit": [
		"5a7c",
		"chunk-1a0a2d9f",
		"chunk-7756441f",
		"chunk-273822c8",
		"chunk-1fb5236e"
	],
	"./footer-links/AddEdit": [
		"6aa4",
		"chunk-7756441f",
		"chunk-2d0da514"
	],
	"./forms/AddEdit": [
		"7ee9",
		"chunk-1a0a2d9f",
		"chunk-7756441f",
		"chunk-7ac7242a",
		"chunk-2d0e28f8"
	],
	"./homepage-components/AddEdit": [
		"3ff4",
		"chunk-7756441f",
		"chunk-66dc6f97"
	],
	"./homepages/AddEdit": [
		"3d1d",
		"chunk-7756441f",
		"chunk-8fc3fc8c"
	],
	"./hugs/AddEdit": [
		"9cdb",
		"chunk-7756441f",
		"chunk-2d0f0a3e"
	],
	"./loan-products/AddEdit": [
		"23b0",
		"chunk-1a0a2d9f",
		"chunk-7756441f",
		"chunk-7ac7532e",
		"chunk-154dda1d"
	],
	"./loan-shops/AddEdit": [
		"9a76",
		"chunk-7756441f",
		"chunk-41722a50"
	],
	"./orders/AddEdit": [
		"bef4",
		"chunk-1a0a2d9f",
		"chunk-1cc91e69"
	],
	"./pages/AddEdit": [
		"3d88",
		"chunk-7756441f",
		"chunk-273822c8",
		"chunk-2d0c4e47"
	],
	"./product-tags/AddEdit": [
		"c9af",
		"chunk-7756441f",
		"chunk-2d2183d1"
	],
	"./product-variants/AddEdit": [
		"93ab",
		"chunk-7756441f",
		"chunk-35e6bb01"
	],
	"./products/AddEdit": [
		"7fa1",
		"chunk-1a0a2d9f",
		"chunk-7756441f",
		"chunk-1fb322a0"
	],
	"./shops/AddEdit": [
		"eb71",
		"chunk-7756441f",
		"chunk-41862e60"
	],
	"./star-products/AddEdit": [
		"b72c",
		"chunk-7756441f",
		"chunk-2d21023c"
	],
	"./student-tag-categories/AddEdit": [
		"e8ce",
		"chunk-7756441f",
		"chunk-2d22690b"
	],
	"./student-tags-list/AddEdit": [
		"8f82",
		"chunk-2d0e9b9e"
	],
	"./student-tags/AddEdit": [
		"3cb4",
		"chunk-7756441f",
		"chunk-2d0c4f98"
	],
	"./students/AddEdit": [
		"3a24",
		"chunk-7756441f",
		"chunk-37165250"
	],
	"./suppliers/AddEdit": [
		"80be",
		"chunk-7756441f",
		"chunk-98683b70"
	],
	"./teachers/AddEdit": [
		"1b1a",
		"chunk-7756441f",
		"chunk-2d0b5d57"
	],
	"./tiers/AddEdit": [
		"e8f5",
		"chunk-7756441f",
		"chunk-2d226938"
	],
	"./transparency/AddEdit": [
		"aa76",
		"chunk-7756441f",
		"chunk-273822c8",
		"chunk-316e3566"
	],
	"./users/AddEdit": [
		"0264",
		"chunk-1a0a2d9f",
		"chunk-7756441f",
		"chunk-2a10fa14"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7531";
module.exports = webpackAsyncContext;